export enum MixtureType {
  'BAIT' = 'BAIT',
}
